module.exports = __webpack_public_path__ + "ea04bab793ddfedc4b5a2bac30bf0d2a.fbx";